import { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import API from '../services/api';

export default function ProyectoEditar() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [form, setForm] = useState({ nombre: '', cliente: '', descripcion: '', estado: 'activo', fecha_inicio: '', fecha_fin: '', presupuesto: '', precio_hora_venta: '' });
  const [clientes, setClientes] = useState([]);
  const [sugerencias, setSugerencias] = useState([]);
  const [error, setError] = useState('');
  const [guardando, setGuardando] = useState(false);

  useEffect(() => {
    Promise.all([API.get('/proyectos'), API.get('/clientes')]).then(([pRes, cRes]) => {
      const p = pRes.data.find(x => x.id === parseInt(id));
      if (p) setForm({
        nombre: p.nombre||'', cliente: p.cliente||'', descripcion: p.descripcion||'',
        estado: p.estado||'activo', fecha_inicio: p.fecha_inicio?.split('T')[0]||'',
        fecha_fin: p.fecha_fin?.split('T')[0]||'', presupuesto: p.presupuesto||'',
        precio_hora_venta: p.precio_hora_venta||''
      });
      setClientes(cRes.data);
    });
  }, [id]);

  const buscarCliente = (val) => {
    setForm({...form, cliente: val});
    if (val.length > 0) {
      setSugerencias(clientes.filter(c => c.nombre.toLowerCase().includes(val.toLowerCase())).slice(0, 5));
    } else {
      setSugerencias([]);
    }
  };

  const guardar = async () => {
    setError('');
    if (!form.nombre.trim()) { setError('El nombre es obligatorio'); return; }
    setGuardando(true);
    try {
      await API.put(`/proyectos/${id}`, {
        nombre: form.nombre, cliente: form.cliente||null, descripcion: form.descripcion||null,
        estado: form.estado, fecha_inicio: form.fecha_inicio||null, fecha_fin: form.fecha_fin||null,
        presupuesto: form.presupuesto ? parseFloat(form.presupuesto) : null,
        precio_hora_venta: form.precio_hora_venta ? parseFloat(form.precio_hora_venta) : null,
      });
      navigate(`/proyectos/${id}`);
    } catch(e) { setError('Error al guardar'); setGuardando(false); }
  };

  return (
    <div style={s.page}>
      <div style={s.topbar}>
        <button style={s.backBtn} onClick={() => navigate(`/proyectos/${id}`)}>← Proyecto</button>
      </div>
      <div style={s.content}>
        <div style={s.card}>
          <div style={s.cardTitle}>Editar proyecto</div>
          {error && <div style={s.errorBox}>{error}</div>}
          <div style={s.field}><label style={s.label}>Nombre *</label><input style={s.input} value={form.nombre} onChange={e => setForm({...form, nombre: e.target.value})} /></div>
          <div style={{...s.field, position:'relative'}}>
            <label style={s.label}>Cliente</label>
            <input style={s.input} value={form.cliente} onChange={e => buscarCliente(e.target.value)} placeholder="Nombre del cliente" autoComplete="off" />
            {sugerencias.length > 0 && (
              <div style={s.dropdown}>
                {sugerencias.map(c => (
                  <div key={c.id} style={s.dropdownItem} onClick={() => { setForm({...form, cliente: c.nombre}); setSugerencias([]); }}>
                    {c.nombre}
                  </div>
                ))}
              </div>
            )}
          </div>
          <div style={s.field}><label style={s.label}>Descripción</label><textarea style={{...s.input, height:96, resize:'vertical'}} value={form.descripcion} onChange={e => setForm({...form, descripcion: e.target.value})} /></div>
          <div style={s.field}>
            <label style={s.label}>Estado</label>
            <select style={s.input} value={form.estado} onChange={e => setForm({...form, estado: e.target.value})}>
              <option value="activo">Activo</option>
              <option value="pausado">Pausado</option>
              <option value="cerrado">Cerrado</option>
            </select>
          </div>
          <div style={s.fieldRow}>
            <div style={{...s.field, flex:1}}><label style={s.label}>Fecha inicio</label><input style={s.input} type="date" value={form.fecha_inicio} onChange={e => setForm({...form, fecha_inicio: e.target.value})} /></div>
            <div style={{...s.field, flex:1}}><label style={s.label}>Fecha fin</label><input style={s.input} type="date" value={form.fecha_fin} onChange={e => setForm({...form, fecha_fin: e.target.value})} /></div>
          </div>
          <div style={s.fieldRow}>
            <div style={{...s.field, flex:1}}><label style={s.label}>Presupuesto (€)</label><input style={s.input} type="number" value={form.presupuesto} onChange={e => setForm({...form, presupuesto: e.target.value})} /></div>
            <div style={{...s.field, flex:1}}><label style={s.label}>Precio hora venta (€)</label><input style={s.input} type="number" value={form.precio_hora_venta} onChange={e => setForm({...form, precio_hora_venta: e.target.value})} /></div>
          </div>
          <div style={s.footer}>
            <button style={s.btnSecondary} onClick={() => navigate(`/proyectos/${id}`)}>Cancelar</button>
            <button style={s.btn} onClick={guardar} disabled={guardando}>{guardando ? 'Guardando...' : 'Guardar cambios'}</button>
          </div>
        </div>
      </div>
    </div>
  );
}

const s = {
  page: { display:'flex', flexDirection:'column', minHeight:'100vh', background:'#f5f5f3', fontFamily:'-apple-system, BlinkMacSystemFont, Inter, sans-serif' },
  topbar: { background:'white', borderBottom:'0.5px solid #e0e0d8', padding:'0 24px', height:48, display:'flex', alignItems:'center' },
  backBtn: { background:'none', border:'none', fontSize:13, color:'#378ADD', cursor:'pointer', fontWeight:500 },
  content: { padding:24, maxWidth:600 },
  card: { background:'white', border:'0.5px solid #e0e0d8', borderRadius:12, padding:24 },
  cardTitle: { fontSize:16, fontWeight:600, color:'#1a1a1a', marginBottom:24 },
  errorBox: { background:'#FCEBEB', color:'#A32D2D', borderRadius:8, padding:'10px 14px', fontSize:13, marginBottom:16 },
  field: { marginBottom:16 },
  fieldRow: { display:'flex', gap:12 },
  label: { display:'block', fontSize:13, color:'#444', marginBottom:6, fontWeight:500 },
  input: { width:'100%', padding:'9px 12px', borderRadius:8, border:'0.5px solid #d0d0c8', fontSize:14, outline:'none', boxSizing:'border-box', background:'white' },
  dropdown: { position:'absolute', top:'100%', left:0, right:0, background:'white', border:'0.5px solid #d0d0c8', borderRadius:8, zIndex:100, boxShadow:'0 4px 12px rgba(0,0,0,0.1)' },
  dropdownItem: { padding:'10px 12px', fontSize:13, cursor:'pointer', borderBottom:'0.5px solid #f0f0ed' },
  footer: { display:'flex', justifyContent:'flex-end', gap:10, marginTop:24, paddingTop:16, borderTop:'0.5px solid #f0f0ed' },
  btn: { background:'#378ADD', color:'white', border:'none', borderRadius:8, padding:'8px 18px', fontSize:13, fontWeight:500, cursor:'pointer' },
  btnSecondary: { background:'white', color:'#666', border:'0.5px solid #d0d0c8', borderRadius:8, padding:'8px 14px', fontSize:13, cursor:'pointer' },
};
